/**
 * DRMDTO entity class
 */

/**
 * DRMDTOFactory
 * returns DRMDTO entity class
 *
 * @class DRMDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.DRMDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:DRMDTOFactory
 */
/* @ngInject */
export default function DRMDTOFactory (Entity) {
  /* === DRMDTO class === */

  /**
   * DRMDTO model
   *
   * @class DRMDTO
   * @classdesc DRMDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing DRMDTO entity fields
   * @return {models.DRMDTO} DRMDTO entity
   */
  function DRMDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  DRMDTO.prototype = Object.create(Entity.prototype)
  DRMDTO.prototype.constructor = DRMDTO

  /* === DRMDTO instance methods & fields === */

  Object.assign(DRMDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.DRMDTO#
     * @type {Object}
     */
    _fields: {
      providerName: String,
      systems: [String] /* SETRIX_DRM_SYSTEMS_TYPES */
    }
  })

  /**/

  /* === DRMDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(DRMDTO, Entity)
  DRMDTO._name = 'DRMDTO'
  DRMDTO.init()

  return DRMDTO
}
